<!--begin::Card-->
<div class="card">
  <!--begin::Card header-->
  <div class="card-header border-0 pt-6">
    <!--begin::Card title-->
    <div class="card-title">
      <!--begin::Search-->
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="onSearch()"
               class="form-control form-control-solid w-250px ps-13"
               placeholder="Search inspections..." />
      </div>
      <!--end::Search-->
    </div>
    <!--begin::Card title-->
    <!--begin::Card toolbar-->
    <div class="card-toolbar">
      <!--begin::Toolbar-->
      <div class="d-flex justify-content-end" data-kt-inspection-table-toolbar="base">
        <!--begin::Send Mail (Bulk)-->
        <button type="button" class="btn btn-sm btn-success fw-bold d-flex me-3"
                *ngIf="hasSelectedInspections" (click)="sendBulkMail()" [disabled]="isSendingBulkMail">
          <span class="spinner-border spinner-border-sm me-2" role="status" *ngIf="isSendingBulkMail">
            <span class="visually-hidden">Loading...</span>
          </span>
          <i class="ki-duotone ki-sms fs-6 me-1" *ngIf="!isSendingBulkMail">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>{{ isSendingBulkMail ? 'Sending...' : 'Send Mail (' + selectedInspections.size + ')' }}</span>
        </button>
        <!--end::Send Mail (Bulk)-->
        <!--begin::Filter-->
        <button type="button" class="btn btn-sm btn-dark fw-bold d-flex me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Search</span>
        </button>
        <!--end::Filter-->
        <!--begin::Add inspection-->
        <button type="button" class="btn btn-sm btn-primary fw-bold d-flex" (click)="openAddModal()">
          <i class="ki-duotone ki-plus fs-2"></i>Add Inspection
        </button>
        <!--end::Add inspection-->
      </div>
      <!--end::Toolbar-->
    </div>
    <!--end::Card toolbar-->
  </div>
  <!--end::Card header-->

  <!--begin::Filters-->
  <div class="card-body border-bottom py-4" *ngIf="showFiltersForm">
    <div class="row g-4">
      <!-- Insp Apply Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Insp Apply Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.insp_apply_date_from" />
      </div>

      <!-- Insp Apply Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Insp Apply Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.insp_apply_date_to" />
      </div>

      <!-- Insp Passed Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Insp Passed Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.insp_passed_date_from" />
      </div>

      <!-- Insp Passed Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Insp Passed Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.insp_passed_date_to" />
      </div>
    </div>

    <div class="row g-4 mt-2">
      <!-- Insp Agency -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Insp Agency</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search agency..."
            [(ngModel)]="inspAgencySearchTerm"
            (input)="onInspAgencySearchInput($event)"
            (focus)="onInspAgencyInputFocus()"
            (blur)="onInspAgencyInputBlur()"
            autocomplete="off" />

          <!-- Loading spinner -->
          <div class="position-absolute top-50 end-0 translate-middle-y me-3" *ngIf="isInspAgencySearching">
            <span class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </span>
          </div>

          <!-- Dropdown results -->
          <div class="dropdown-menu show w-100" *ngIf="showInspAgencyDropdown && inspAgencySearchResults.length > 0"
               style="max-height: 300px; overflow-y: auto;">
            <a class="dropdown-item cursor-pointer"
               *ngFor="let agency of inspAgencySearchResults"
               (click)="selectInspAgency(agency)">
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ agency.name || agency.company_name }}</span>
              </div>
            </a>
          </div>

          <!-- No results message -->
          <div class="dropdown-menu show w-100" *ngIf="showInspAgencyDropdown && inspAgencySearchResults.length === 0 && !isInspAgencySearching">
            <div class="dropdown-item text-muted">No agencies found</div>
          </div>
        </div>
      </div>

      <!-- Insp Status -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Insp Status</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.insp_status">
          <option value="">All</option>
          <option value="Pending">Pending</option>
          <option value="In Process">In Process</option>
          <option value="Failed">Failed</option>
          <option value="Passed">Passed</option>
        </select>
      </div>

      <!-- Search Keyword -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Search Keyword</label>
        <input type="text" class="form-control form-control-sm" placeholder="Enter keyword..." [(ngModel)]="filters.search" />
      </div>

      <!-- Filter Actions -->
      <div class="col-md-3 d-flex align-items-end justify-content-end">
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-sm btn-danger" (click)="applyFilters()">
            <i class="ki-duotone ki-magnifier fs-3">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Apply Filters
          </button>
          <button type="button" class="btn btn-sm btn-secondary" (click)="clearFilters()">
            <i class="ki-duotone ki-cross fs-3">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--end::Filters-->

  <!--begin::Card body-->
  <div class="card-body py-4">
    <!--begin::Table-->
    <div class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_inspection_table">
        <!--begin::Table head-->
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="w-10px pe-2">
              <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                <input class="form-check-input" type="checkbox"
                       [checked]="selectAll"
                       (change)="toggleSelectAll()" />
              </div>
            </th>
            <th class="min-w-125px">Stock</th>
            <th class="min-w-125px">Destination Country</th>
            <th class="min-w-125px">Insp Agency</th>
            <th class="min-w-100px">Insp Apply Date</th>
            <th class="min-w-100px">Insp Passed Date</th>
            <th class="min-w-100px">Insp Status</th>
            <th class="min-w-100px">Yard Name</th>
            <th class="min-w-100px">Cost</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
        </thead>
        <!--end::Table head-->
        <!--begin::Table body-->
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngIf="isLoading">
            <td colspan="9" class="text-center py-10">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </td>
          </tr>
          <tr *ngIf="!isLoading && inspections.length === 0">
            <td colspan="9" class="text-center py-10">
              <div class="text-muted">No inspection records found</div>
            </td>
          </tr>
          <tr *ngFor="let inspection of inspections">
            <!--begin::Checkbox-->
            <td>
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input class="form-check-input" type="checkbox"
                       [checked]="isInspectionSelected(inspection._id || inspection.id)"
                       (change)="toggleInspectionSelection(inspection._id || inspection.id)" />
              </div>
            </td>
            <!--end::Checkbox-->
            <!--begin::Stock-->
            <td>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-45px me-5">
                  <img [src]="getVehicleImageUrl(inspection.vehicle)" alt="Vehicle" />
                </div>
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">
                    {{ inspection.vehicle?.name || 'N/A' }}
                  </span>
                  <span class="text-muted fw-semibold text-muted d-block fs-7">
                    {{ inspection.vehicle?.car_no || 'N/A' }}
                  </span>
                </div>
              </div>
            </td>
            <!--end::Stock-->
            <!--begin::Destination Country-->
            <td>
              <span class="text-dark fw-bold d-block fs-6">
                {{ inspection.destination_country || 'N/A' }}
              </span>
            </td>
            <!--end::Destination Country-->
            <!--begin::Insp Agency-->
            <td>
              <span class="text-dark fw-bold d-block fs-6">
                {{ inspection.insp_agency?.company_name || 'N/A' }}
              </span>
            </td>
            <!--end::Insp Agency-->
            <!--begin::Insp Apply Date-->
            <td>
              <span class="text-dark fw-bold d-block fs-6">
                {{ inspection.insp_apply_date ? (inspection.insp_apply_date | date:'dd/MM/yyyy') : 'N/A' }}
              </span>
            </td>
            <!--end::Insp Apply Date-->
            <!--begin::Insp Passed Date-->
            <td>
              <span class="text-dark fw-bold d-block fs-6">
                {{ inspection.insp_passed_date ? (inspection.insp_passed_date | date:'dd/MM/yyyy') : 'N/A' }}
              </span>
            </td>
            <!--end::Insp Passed Date-->
            <!--begin::Insp Status-->
            <td>
              <span class="badge"
                    [ngClass]="{
                      'badge-light-warning': inspection.insp_status === 'In Process',
                      'badge-light-info': inspection.insp_status === 'Pending',
                      'badge-light-success': inspection.insp_status === 'Passed',
                      'badge-light-danger': inspection.insp_status === 'Failed'
                    }">
                {{ inspection.insp_status || 'N/A' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-bold d-block fs-6">
                {{ inspection.vehicle?.yard_name || 'N/A' }}
              </span>
            </td>
            <!--end::Insp Status-->
            <!--begin::Cost-->
            <td>
              <span class="text-dark fw-bold d-block fs-6">
                {{ inspection.cost ? (inspection.cost + ' JPY') : 'N/A' }}
              </span>
            </td>
            <!--end::Cost-->
            <!--begin::Action-->

            <!--end::Action-->

            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Send Mail Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-success"
                  (click)="sendSingleMail(inspection)"
                  title="Send Mail">
                  <i class="ki-duotone ki-sms fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditModal(inspection)"
                  title="Edit Inspection">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteInspection(inspection)"
                  title="Delete Inspection">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
        <!--end::Table body-->
      </table>
    </div>
    <!--end::Table-->

    <!--begin::Pagination-->
    <app-pagination
      *ngIf="!isLoading && inspections.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
    <!--end::Pagination-->
  </div>
  <!--end::Card body-->
</div>
<!--end::Card-->

<!-- Include the add-edit modal -->
<app-add-edit-inspection-manager
  (inspectionAdded)="onInspectionAdded()"
  (inspectionUpdated)="onInspectionUpdated()">
</app-add-edit-inspection-manager>
